import { Bootstrapper } from 'react-habitat';
import CustomContainerBuilder from './CustomContainerBuilder';
import CustomDomFactory from './CustomDomFactory';
import registrations from './registrations';
class MyApp extends Bootstrapper {
    constructor() {
        super();
        // Create container builder instance.
        const containerBuilder = new CustomContainerBuilder();
        // Set a custom factory to handle any context providers.
        containerBuilder.factory = new CustomDomFactory();
        // Register components - async allows for code splitting.
        registrations.forEach((registration) => {
            containerBuilder.registerIfPresent(registration.component, registration.name);
        });
        // Finally, set the container.
        this.setContainer(containerBuilder.build());
    }
}
// Always export a 'new' instance so it immediately evokes
export default new MyApp();
